
import CookieBannerMixin from '~/mixins/cookieBanner'
import BodyClassMixin from '~/mixins/bodyClass'
import themeMixin from '~/mixins/theme'

export default {
  mixins: [CookieBannerMixin, BodyClassMixin, themeMixin],
}
